import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Train } from 'src/app/models/train.model';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Plant } from 'src/app/models/plant.model';
import { Unit } from 'src/app/models/unit.interface';
import { UserService } from 'src/app/services/user/user.service';
import { ModelsService } from 'src/app/services/models/models.service';
import { ToastrService } from 'ngx-toastr';
import { RawOpdata } from 'src/app/models/opdata.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';

@Component({
  selector: 'app-add-opdata',
  templateUrl: './add-opdata.component.html',
  styleUrls: ['./add-opdata.component.scss']
})
export class AddOpdataComponent {
  dtoptions: DataTables.Settings = {};
  public units: Array<Unit> = [
    { Id: 0, UnitName: 'English' },
    { Id: 1, UnitName: 'Metric' },
  ];
  
  SelectedId: string;
  
  plants: Plant[] = [];
  trains: Train[] = [];
  opdataModel:RawOpdata=new RawOpdata();
  
  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;
  
  plantId: number;
  trainId:string;
  noOfStages:number = 0;
  UserDefinedField1:string;
  UserDefinedField2:string;
  UserDefinedField3:string;
  UserDefinedField4:string;
  UserDefinedField5:string;
  showUserDefinedField1:boolean=false;
  showUserDefinedField2:boolean=false;
  showUserDefinedField3:boolean=false;
  showUserDefinedField4:boolean=false;
  showUserDefinedField5:boolean=false;
  showUserDefinedDiv:boolean=false;
  selectedTrain:Train=new Train();
  loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
  
  CurrentUserId = this.loggedInuserRole.userId;
    
  
  constructor(
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private userService: UserService,
    private modelService: ModelsService,
    private toastr : ToastrService,
    private opdataService:OpdataService
    
  ) { }

  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
    };
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (loggedInuserRole.role == 'Standard User') {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
        .subscribe({
          next: (plants) => {
            this.plants = plants;
          },
        })

    }
    else {
      this.plantService.getAllPlant().subscribe({
        next: (plants) => {
          this.plants = plants;
          console.log(this.plants);

        },
        error: (response) => {
          console.log(response);
        },
      });
    }

           //load data using plantId from breadcrumbs
    this.plantService.selectedPlant$.subscribe(plantId => {
     if (plantId != null) {
          this.getSelectedPlantId({ target: { value: plantId } });
      }
    });

           //load data using trainId from breadcrumbs
    this.plantService.selectedTrain$.subscribe(trainId => {
      if (trainId != null) {
          this.getSelectedTrainDetails({ target: { value: trainId } });
      }
    }); 
  //  // get trainid from breadcrumbs
  //    this.plantService.selectedTrain$
  //     .subscribe(trainId => {
  //       if (trainId) {
  //         this.getSelectedTrainDetails({ target: { value: trainId } });
  //       }
  //     });
  }

  getSelectedTrainDetails(e)
  {
    this.trainId = e.target.value;
    
    this.trainService.getTrainById(this.trainId).subscribe(
      (response: Train) => {
        this.selectedTrain = response;
        this.plantId = this.selectedTrain.PlantId;
        this.noOfStages=this.selectedTrain.Stages;
        this.UserDefinedField1 = this.selectedTrain.Ud1;
        this.UserDefinedField2 = this.selectedTrain.Ud2;
        this.UserDefinedField3 = this.selectedTrain.Ud3;
        this.UserDefinedField4 = this.selectedTrain.Ud4;
        this.UserDefinedField5 = this.selectedTrain.Ud5;
        //added on 26th February 2025
        this.checkUserDefinedField();
        this.IsUserDefinedDivVisible();
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }

  getSelectedPlantId(e)
  {
    this.SelectedId = e.target.value;
    this.plantId=e.target.value;




    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.plantId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
      
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {

    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }
  }
  addRawOpData() {
    var rawOpdata = this.opdataModel;
    console.log(this.opdataModel);
    rawOpdata.AspNetUsersId=this.CurrentUserId;
    rawOpdata.Valid=1;
  //  rawOpdata.TrainId = this.selectedTrain.Id;
    this.opdataService.addRawOpdata(this.selectedTrain.Id, rawOpdata).subscribe({
      next: (model) => {

        this.toastr.success('Opdata and OpdataCalc Added Successfully.', 'Information')
        // this.router.navigate(['/opdata'], {
        //  // queryParams: {PlantId: btoa(this.plantId.toString()), trainId:  btoa(this.opdataModel.TrainId.toString())},
        //   queryParams: {PlantId: btoa(this.plantId.toString()), trainId: btoa(this.selectedTrain.Id.toString())},
        //  skipLocationChange: true,
        // });

        this.router.navigate(['/opdata'], {
          state: {
            PlantId: this.plantId,
            trainId: this.selectedTrain.Id
          },
          skipLocationChange: true
        });
      },
    });
  }
  IsUserDefinedDivVisible()
{
  if(this.UserDefinedField1 !='' ||this.UserDefinedField2 !='' || this.UserDefinedField3 !='' ||this.UserDefinedField4!=''||this.UserDefinedField5!='')
  {
    this.showUserDefinedDiv=true;
  }
  else{
    this.showUserDefinedDiv=false;
  }

}
  checkUserDefinedField() {
    if (this.UserDefinedField1 === "") {
      this.showUserDefinedField1 = false;

    }
    else {
      this.showUserDefinedField1 = true;
    }
    if (this.UserDefinedField2 === "") {
      this.showUserDefinedField2 = false;

    }
    else {
      this.showUserDefinedField2 = true;
    }
    if (this.UserDefinedField3 === "") {
      this.showUserDefinedField3 = false;

    }
    else {
      this.showUserDefinedField3 = true;
    }
    if (this.UserDefinedField4 === "") {
      this.showUserDefinedField4 = false;

    }
    else {
      this.showUserDefinedField4 = true;
    }
    if (this.UserDefinedField5 === "") {
      this.showUserDefinedField5 = false;

    }
    else {
      this.showUserDefinedField5 = true;
    }
  }
  
}
